import i18n from '@/locales'
export default {
  created () {
    this.columns = [
      {
        field: 'id',
        title: 'ID',
        minWidth: 100,
        slots: {
          default: ({ row }, h) => {
            return [<list-body-cell-wrap copy hideField row={ row } field='id' title={ row.id + '' } message={ row.id + '' } >
              <side-page-trigger onTrigger={() => this.handleOpenSidepage(row)}>{ row.id + ''}</side-page-trigger>
            </list-body-cell-wrap>]
          },
        },
      },
      {
        field: 'name',
        title: i18n.t('op_30'),
      },
    ]
  },
}
